import {
  Chip,
  FormControl,
  IconButton,
  Input,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from "@material-ui/core";
import moment from "moment";
import React from "react";
import { API_URL } from "../../constants/api";
import { apiPost, apiRequest } from "../../utils/api_service";
import SaveIcon from "@material-ui/icons/Save";
import { ShowToast, toastType } from "../../utils/toast-service";
class ConfigureGuardForcePatrols extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      datacenterList: undefined,
      SelectedDC: [],
      PatrolsPerMonth: 0,
      PatrolType: undefined,
      PerDayPatrols: undefined,
      SaveStatus: true,
      GuardForceList: [],
      startDate: moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
    };
  }

  /**
   * onload function
   */
  componentDidMount() {
    this.getDataCenterList();
    this.getGuardForceList();
  }

  /**
   * fetch data center list
   */
  getDataCenterList = () => {
    apiRequest({ url: API_URL.datacenter.getDatacenterList }).then(
      ({ data: datacenterList }) => {
        this.setState({
          datacenterList: datacenterList,
        });
      }
    );
  };

  /**
   * fetch guard force list
   */
  getGuardForceList = () => {
    const params = {
      propertyId: 0,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
    };
    apiRequest({
      url: API_URL.security.GetGuardForcePatrolsByProperty,
      params,
    }).then(({ data: GuardForceList }) => {
      //console.log(GuardForceList);
      this.setState({
        GuardForceList: GuardForceList,
      });
    });
  };

  /**
   * handle change
   * @param {*} e 
   * @param {*} type 
   */
  handleChange = (e, type) => {
    let {SelectedDC} = this.state;
    if (type == "value") {

      if (SelectedDC.indexOf(e[e.length - 1]) !== -1) {
        SelectedDC = [];
        SelectedDC = e;
      } else {
        if (e[e.length - 1] != undefined) {
          SelectedDC.push(e[e.length - 1]);
        } else {
          SelectedDC = [];
        }
      }
    } else {
      const filteredAry = SelectedDC.filter(function(w) {
        return w !== e;
      });
      SelectedDC = filteredAry;
    }

    this.setState({ SelectedDC: SelectedDC, SaveStatus: true });
  };

  /**
   * call on change for Patrol day
   * @param {*} e 
   * @returns 
   */
  handelPatrolDayChange = (e) => {
    if (e < 0) {
      ShowToast(
        "Please enter positive value for patrols",
        toastType.ERROR,
        5000,
        200
      );
      this.setState({ PerDayPatrols: undefined });
      return false;
    }
    if (isNaN(e) == false && Number.isInteger(e) == false) {
      ShowToast(
        "Decimal values are not allowed in patrols",
        toastType.ERROR,
        5000,
        200
      );
      this.setState({ PerDayPatrols: undefined });
      return false;
    }

    let {PatrolsPerMonth} = this.state;
    const PerDay = e;
    const daysInCurrentMonth = moment().daysInMonth();

    PatrolsPerMonth = daysInCurrentMonth * PerDay;
    this.setState({
      PatrolsPerMonth: PatrolsPerMonth,
      PerDayPatrols: e,
      SaveStatus: true,
    });
  };

  /**
   * call on save configuration click
   * @returns 
   */
  saveConfiguration = () => {
    if (this.state.SelectedDC.length == 0) {
      ShowToast("Please select datacenter", toastType.ERROR, 5000, 200);
      return false;
    } else if (this.state.PatrolType == undefined) {
      ShowToast("Please select tour type", toastType.ERROR, 5000, 200);
      return false;
    } else if (this.state.PerDayPatrols == undefined) {
      ShowToast("Please enter per day tours", toastType.ERROR, 5000, 200);
      return false;
    }

    const PropertyIDsByName = [];
    this.state.SelectedDC.forEach((x) => {
      PropertyIDsByName.push(this.getPropertyIDIdByName(x));
    });

    const Value = this.state.PerDayPatrols + "|" + "1";
    const bodyToPost = {
      propertyId: PropertyIDsByName.toString(),
      sectionDetailId: parseInt(this.state.PatrolType),
      attributeValue: Value,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
    };
    //console.log(bodyToPost);
    apiPost({
      url: API_URL.datacenter.UpdateDataCenterAttribute,
      params: [],
      postBody: bodyToPost,
    }).then(({ data: response }) => {
      if (response.success == true) {
        ShowToast("Record updated successfully.", toastType.SUCCESS, 5000, 200);
        this.getGuardForceList();
        this.setState({ SaveStatus: false });
      }
    });
  };

  /**
   * Return property Id for given
   * @param {*} Name 
   * @returns 
   */
  getPropertyIDIdByName = (Name) => {
    const data = this.state.datacenterList;
    let a;
    data.map((item) => {
      if (item.name == Name) {
        a = item.propertyID;
      }
    });
    return a;
  };

  render() {
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 400,
        },
      },
    };

    return (
      <>
        <Table
          aria-labelledby={"tableMenuTitle"}
          size={"small"}
          aria-label={"configuration table"}
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={"configureHeader"}
                className={"content-header"}
                colSpan={2}
              >
                <div className={"content-header d-flex"}>
                  {" "}
                  <div
                    className={"col-xs-11"}
                    style={{ display: "inline-block", alignItems: "center" }}
                  >
                    {"Configure Virtual and Schedule Patrols\r"}
                  </div>
                  <div className={"col-xs-1"}>
                    {this.state.SaveStatus ? (
                      <Tooltip title={"Save"}>
                        <IconButton
                          size={"small"}
                          onClick={this.saveConfiguration}
                          style={{ color: "#FFFFFF" }}
                        >
                          <SaveIcon
                            size={"small"}
                            style={{ fill: "#FFFFFF" }}
                          />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                  </div>
                </div>
              </TableCell>
              {/* <TableCell style={{ textAlign: "right" }}>
               
              </TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>{" Select Data Center"}</TableCell>
              <TableCell>
                {" "}
                <FormControl style={{ minWidth: 300 }}>
                  {/* <InputLabel id="demo-multiple-chip-label">With</InputLabel> */}
                  <Select
                    labelId={"demo-multiple-chip-label"}
                    id={"demo-multiple-chip"}
                    multiple
                    style={{ width: "100%" }}
                    value={this.state.SelectedDC}
                    onChange={(e) => this.handleChange(e.target.value, "value")}
                    input={<Input id={"select-multiple-chip"} />}
                    renderValue={(selected) => (
                      <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {selected.map((value, index) => (
                          <Chip
                            key={value + index}
                            label={value}
                            style={{ margin: "2px" }}
                            onDelete={() => this.handleChange(value, "chip")}
                            onMouseDown={(event) => {
                              event.stopPropagation();
                            }}
                          />
                        ))}
                      </div>
                    )}
                    MenuProps={MenuProps}
                  >
                    {(this.state.datacenterList || []).map((item) => (
                      <MenuItem key={item.propertyID} value={item.name}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>{" Select Patrol Type"}</TableCell>
              <TableCell>
                <Select
                  style={{ minWidth: 300 }}
                  native
                  onChange={(e) =>
                    this.setState({
                      PatrolType: e.target.value,
                      SaveStatus: true,
                    })}
                >
                  <option aria-label={"None"} value={this.state.PatrolType} />
                  <option value={17}>{"Security - Physical Patrol"}</option>
                  <option value={19}>{"Security - Virtual Patrol"}</option>
                </Select>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>{" Enter Patrols Per Day "}</TableCell>
              <TableCell>
                {" "}
                <TextField
                  style={{ minWidth: 300 }}
                  id={"standard-basic"}
                  type={"number"}
                  InputProps={{ inputProps: { min: 0, max: 10000 } }}
                  onChange={(e) =>
                    this.handelPatrolDayChange(parseFloat(e.target.value))}
                />{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{" Total Scheduled Patrols For Current Month"}</TableCell>
              <TableCell>
                {" "}
                <span>
                  {isNaN(this.state.PatrolsPerMonth)
                    ? null
                    : this.state.PatrolsPerMonth}
                </span>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell colSpan={2}>
                <Table style={{ minWidth: "650" }} aria-label={"simple table"}>
                  <TableHead>
                    <TableRow>
                      <TableCell>{"Data Center Name"}</TableCell>
                      <TableCell align={"right"}>
                        {"Scheduled Physical Patrols"}{" "}
                      </TableCell>
                      <TableCell align={"right"}>
                        {"Scheduled VirtualPatrols\r"}
                      </TableCell>
                      <TableCell align={"right"}>
                        {"Total Scheduled Physical Patrols\r"}
                      </TableCell>
                      <TableCell align={"right"}>
                        {"Total Scheduled Virtual Patrols\r"}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.GuardForceList.map((row) => (
                      <TableRow key={row.name}>
                        <TableCell component={"th"} scope={"row"} align={"left"}>
                          {row.propertyName}
                        </TableCell>
                        <TableCell align={"right"}>
                          {row.scheduledPhysicalPatrolsPerDay}
                        </TableCell>
                        <TableCell align={"right"}>
                          {row.scheduledVirtualPatrolsPerday}
                        </TableCell>
                        <TableCell align={"right"}>
                          {row.totalScheduledPhysicalPatrols}
                        </TableCell>
                        <TableCell align={"right"}>
                          {row.totalScheduledVirtualPatrols}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  }
}

export default ConfigureGuardForcePatrols;
